<template>
    <div>
        <o-div-table ref="tableList" :title="$t('sandoz.verifications')"
                     :url="'/api/verifications/contracts/' + $route.params.id + '?include=contract_kam_line'">
            <template slot="meta" slot-scope="meta">
                <b-row class="contract_detail">
                    <div class="col-sm mb-3 mwp-100">
                        <o-form-group :label="$t('sandoz.year')" class="d-inline align-top">
                            <div v-if="meta.item.contract"
                                 :class="{'badge badge-danger': (new Date()).getYear()+1900 != meta.item.contract.contract_year}">
                              {{meta.item.contract.contract_year}}
                            </div>
                        </o-form-group>
                    </div>
                    <div class="col-sm mb-3 mw-200 d-md-none" v-if="canDownload (meta)">
                        <o-form-group :label="$t('sandoz.contract')" class="d-inline align-top">
                          <div>{{meta.item.contract.contract_no}}</div>

                          <a :href="'/api/contracts/' + meta.item.contract.contract_id + '/pdf?' + (new Date()).getTime()" target="_blank">
                            <fa icon="download"/> {{$t('sandoz.pdf')}}
                          </a>
                        </o-form-group>
                    </div>
                    <div class="col-sm mb-3">
                        <o-form-group :label="$t('sandoz.name')" class="d-inline align-top">
                            <div class="text-pre"
                                 v-html="meta.item.contract && meta.item.contract.name ? meta.item.contract.name : ''">
                            </div>
                        </o-form-group>
                    </div>
                    <div class="col-sm mb-3 d-none d-sm-block">
                        <o-form-group :label="$t('sandoz.address')" class="d-inline align-top">
                            <div class="text-pre"
                                 v-html="meta.item.contract && meta.item.contract.address ? meta.item.contract.address : ''">
                            </div>
                        </o-form-group>
                    </div>
                    <div class="col-sm mb-3 mw-200 d-none d-md-block" v-if="canDownload (meta)">
                        <o-form-group :label="$t('sandoz.contract')" class="d-inline align-top">
                            <div>{{meta.item.contract.contract_no}}</div>

                            <a :href="'/api/contracts/' + meta.item.contract.contract_id + '/pdf?' + (new Date()).getTime()" target="_blank">
                              <fa icon="download"/> {{$t('sandoz.pdf')}}
                            </a>
                        </o-form-group>
                    </div>
                </b-row>
            </template>
            <template slot="filter">
                <o-filter :default-filter="defaultFilter" v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)">
                    <o-filter-select :items="status" :title="$t('sandoz.status')" column="status"></o-filter-select>
                    <o-filter-select :items="dateStatus" :title="$t('sandoz.date')" column="planned_verification">
                    </o-filter-select>
                </o-filter>
            </template>
            <template slot="head">
                <div class="col-md pb-1 pl-0">{{ $t('sandoz.product_name') }}</div>
                <div class="col-md col-lg pb-1 pl-0">{{$t('sandoz.quantity')}}</div>
                <div class="col-md col-lg pb-1 pl-0">{{$t('sandoz.price')}}</div>
                <div class="col-md col-lg pb-1 pl-0">{{$t('sandoz.comment')}}</div>
                <div class="col-md col-lg pb-1 pl-0">{{$t('sandoz.disclosure')}}</div>
                <div class="col-md col-lg pb-1 pl-0">{{ $t('sandoz.date') }}</div>
                <div class="col-md-3 col-lg-2 pb-1 pl-0 pr-0"></div>
            </template>
            <template slot="body" slot-scope="props">
                <div class="col-md pb-1 pl-0">{{ props.item.contract_kam_line.data.product_name}}</div>
                <div class="col-md col-lg pb-1 pl-0">{{ props.item.contract_kam_line.data.quantity}}</div>
                <div class="col-md col-lg pb-1 pl-0">{{ props.item.contract_kam_line.data.price}}</div>
                <div class="col-md col-lg pb-1 pl-0">{{ props.item.contract_kam_line.data.comment}}</div>
                <div class="col-md col-lg pb-1 pl-0">{{ props.item.contract_kam_line.data.disclosure ? $t('sandoz.yes') : $t('sandoz.no')}}</div>
                <div class="col-md col-lg pb-1 pl-0">
                  {{ props.item.planned_verification | formatDate }} - {{ props.item.planned_verification_end | formatDate }}
                </div>
                <div class="col-md-3 col-lg-2 pb-1 pt-1 pl-0 text-right">
                    <div :ref="'controls_' + props.item.id" aria-label="edit controls" class="btn-group btn-group-sm"
                         role="group">
                        <span class="badge badge-success mr-1 text-capitalize" v-if="props.item.status === 'verified'">
                            {{ props.item.status }}<br>
                            {{ props.item.actual_verification | formatDate }}
                          </span>
                        <span class="badge badge-warning mr-1 text-capitalize" v-if="props.item.status === 'failed'">
                            {{ props.item.status }}<br>
                            {{ props.item.actual_verification | formatDate }}
                        </span>
                        <o-button v-if="props.item.status === 'pending' || props.item.status === 'verified'" native-type="button" variant="primary"
                                  @click="openAllowModel(props.item)">
                            {{ props.item.status === 'pending' ? $t('sandoz.allow'): $t('sandoz.allow_more_pictures')  }}
                        </o-button>
                        <o-button v-if="props.item.status !== 'failed'" native-type="button" variant="warning"
                                  @click="openDenyModel(props.item)">
                          {{ $t('sandoz.deny') }}
                        </o-button>
                        <o-button native-type="button" variant="secondary" :title="$t('sandoz.title_verification_pictures')"
                                  @click="openPictureOverlay(props.item.id)"><fa icon="images"/>
                        </o-button>
                    </div>
                </div>

                <b-modal id="modal-allow" ref="allowModel" :no-close-on-backdrop="true" :no-close-on-esc="true"
                         :ok-only="true" :ok-title="$t('core.cancel')" :title="props.item.status === 'pending' ? $t('sandoz.allow'): ''" size="md"
                         @close="closeAllowModel">
                    <b-alert v-if="findingLocation" show variant="info">{{$t('sandoz.geolocation_loading_msg')}}
                    </b-alert>
                    <b-alert v-else-if="!findingLocation && error" show variant="warning">
                        {{ $t('sandoz.geolocation_error_msg', {message: error}) }}
                    </b-alert>
                    <template v-if="!findingLocation && latitude && longitude">
                        <div class="mb-2">{{ $t('sandoz.upload_file') }}</div>
                        <dropzone :id="''+props.item.id" ref="verificationUpload" :data-eid="props.item.id"
                                  :destroyDropzone="false"
                                  :duplicateCheck="true"
                                  :options="options"
                                  @vdropzone-file-added="vFileAdded"
                                  @vdropzone-sending="vsending"
                                  @vdropzone-error="verror"
                                  @vdropzone-removed-file="vremoved"
                                  @vdropzone-total-upload-progress="vTotalUploadProgress">
                        </dropzone>
                        <o-textarea v-model="note" :label="$t('core.note')" class="mt-3"></o-textarea>
                    </template>
                    <template #modal-footer="{ ok, cancel, hide }">
                        <o-button :loading="saving" native-type="button" variant="secondary"
                                  @click="clearFiles" v-if="noOfFiles">
                          {{ $t('sandoz.reset') }}
                        </o-button>
                        <o-button :loading="saving" native-type="button" variant="primary" @click="saveAndCloseAllowed()">
                          {{ $t('sandoz.save_and_close') }}
                        </o-button>
                    </template>
                </b-modal>

                <b-modal id="modal-deny" ref="denyModel" :ok-only="true" :ok-title="$t('core.cancel')" size="md"
                         :title="$t('sandoz.deny')" @close="closeDenyModel">
                    <o-textarea v-model="note" :label="$t('core.note')"></o-textarea>
                    <template #modal-footer="{ ok, cancel, hide }">
                    <o-button :loading="saving" native-type="button" variant="primary"
                              @click="saveAndCloseDenied(props.item.id)">
                      {{ $t('sandoz.save_and_close') }}
                    </o-button>
                  </template>
                </b-modal>

                <silent-box :gallery="pictures" :lazy-loading="true" class="silentbox-overlay-only" ref="verificationSilentBox">
                </silent-box>
            </template>
        </o-div-table>

        <o-action-toolbar>
            <div class="d-flex w-100">
                <o-button variant="outline-primary" @click.prevent="$router.push({name: 'verifications.verifications'})">
                    {{$t('core.back')}}
                </o-button>
            </div>
        </o-action-toolbar>
    </div>
</template>

<style>
.dropzone {
  padding: 0;
}

.dz-image img {
  max-width: 100%;
}
</style>

<script>
import axios from 'axios'
import Dropzone from 'nuxt-dropzone'
import 'nuxt-dropzone/dropzone.css'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import VueSilentbox from 'vue-silentbox'

Vue.use(VueSilentbox)

export default {
  data() {
    return {
      findingLocation: false,
      latitude: null,
      longitude: null,
      error: null,
      status: [],
      defaultFilter: [],
      saving: false,
      note: null,
      options: {},
      verification: null,
      dateStatus: [],
      pictures: [],
      noOfFiles: 0
    }
  },
  created() {
    this.options = {
      url: '/api/verifications/upload-picture',
      uploadProgress: true,
      progress: true,
      paramName: 'image',
      resizeWidth: 1280,
      resizeHeight: 720,
      thumbnailWidth: 175,
      thumbnailHeight: 175,
      addRemoveLinks: true,
      acceptedFiles: '.png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx,.zip',
      maxFiles: 10,
      resizeMethod: 'contain',
      resizeQuality: 1,
      dictDefaultMessage: this.$i18n.t('sandoz.drop_files')
    }

    this.status = [
      {value: 'pending', text: this.$i18n.t('sandoz.pending')},
      {value: 'verified', text: this.$i18n.t('sandoz.verified')},
      {value: 'failed', text: this.$i18n.t('sandoz.failed')}
    ]

    this.dateStatus = [
      {value: 'past', text: this.$i18n.t('sandoz.past_date')},
      {value: 'future', text: this.$i18n.t('sandoz.future_date')}
    ]

    this.defaultFilter = [{
      column: 'status',
      displayValue: this.$i18n.t('sandoz.pending'),
      title: this.$i18n.t('sandoz.status'),
      value: 'pending'
    }]
  },
  mounted() {
    Dropzone.autoDiscover = false
  },
  components: {
    Dropzone
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  methods: {
    openAllowModel(item) {
      this.verification = item.id
      this.getGeoLocation()
      this.$refs.allowModel.show()
    },
    closeAllowModel() {
      this.verification = null
      this.$refs.allowModel.hide()
    },
    openDenyModel(item) {
      this.verification = item.id
      this.note = item.note
      this.$refs.denyModel.show()
    },
    closeDenyModel() {
      this.verification = null
      this.note = null
      this.$refs.denyModel.hide()
    },
    saveAndCloseDenied() {
      var self = this

      if (!self.note || (typeof self.note === 'string' && !self.note.toString().trim().length)) {
        self.$notify({
          title: self.$i18n.t('core.validation_error'),
          text: self.$i18n.t('core.validation_error_text', {
            message: self.$i18n.t('sandoz.empty_note_error_msg')
          }),
          type: 'error'
        })
        return false
      }

      self.saving = true
      var data = { id: this.verification, note: self.note, is_kam: true, address_id: this.$route.params.id }

      axios.post('/api/verifications/deny', data).then((response) => {
        self.saving = false
        self.$notify({
          title: self.$i18n.t('core.saved'),
          text: self.$i18n.t('sandoz.verification_denied')
        })
        self.$refs['controls_' + this.verification].innerHTML = '<span class="badge badge-warning">' + self.$i18n.t('sandoz.failed') + '</span>'
        self.closeDenyModel()
      }).catch((error) => {
        self.saving = false
        if ('data' in error.response && 'message' in error.response.data) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', {message: error.response.data.message}),
            type: 'error'
          })
        } else {
          self.$notify({
            title: self.$i18n.t('core.save_error'),
            text: self.$i18n.t('core.save_error_text', {url: ''}),
            type: 'error'
          })
        }
        self.closeDenyModel()
      })
    },
    getGeoLocation() {
      // this allows us to open the verification list with ?debug at the end of the URL
      // even on a local server with http:// geoLocation would otherwise only be available
      // if we are using https. With this option we can get past the geolcation
      if ('debug' in this.$route.query) {
        this.latitude = 42
        this.longitude = 7
        this.error = null
        this.findingLocation = false
        return
      }
      if (!('geolocation' in navigator)) {
        this.error = 'Geolocation is not supported by your browser'
        return
      }
      this.findingLocation = true

      navigator.geolocation.getCurrentPosition(position => {
        if (position.coords === undefined) {
          this.error = 'Geolocation service failed'
        } else {
          this.latitude = position.coords.latitude
          this.longitude = position.coords.longitude
          this.error = null
        }
        this.findingLocation = false
      }, error => {
        if (error.code === 1) {
          this.error = 'Geolocation blocked, please unblock to upload pictures'
        } else {
          this.error = error.message
        }
        this.latitude = null
        this.longitude = null
        this.findingLocation = false
      }, {
        // enableHighAccuracy: true,
        // timeout: 5000,
        // maximumAge: 0
      })
    },
    vremoved(file, xhr, error) {
      this.saving = true
      let name = null
      if (typeof file.xhr !== 'undefined' && typeof file.manuallyAdded === 'undefined') {
        name = JSON.parse(file.xhr.response)
      } else if (typeof file.manuallyAdded !== 'undefined' && file.manuallyAdded === true) {
        name = file.name
      }

      let param = { 'image': name, 'id': this.verification, 'is_kam': true, address_id: this.$route.params.id }

      if (name !== null) {
        axios.post('/api/verifications/delete-picture', param).then((response) => {
          this.noOfFiles = this.$refs.verificationUpload.dropzone.files.length
          this.saving = false
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    vsending(file, xhr, formData) {
      this.saving = true
      formData.append('id', this.verification)
      formData.append('contract', this.$route.params.id)
      formData.append('lat', this.latitude)
      formData.append('long', this.longitude)
      formData.append('is_kam', true)
    },
    verror(file, message, xhr) {
      this.$refs.verificationUpload.removeFile(file)
      this.$notify({
        title: this.$i18n.t('core.save_error'),
        text: message.message ? message.message : message,
        type: 'error'
      })
    },
    vFileAdded(file) {
      this.noOfFiles = this.$refs.verificationUpload.dropzone.files.length
    },
    vTotalUploadProgress(totaluploadprogress) {
      if(totaluploadprogress === 100) {
        this.saving = false
      }
    },
    saveAndCloseAllowed() {
      var self = this

      self.saving = true
      var data = { id: this.verification, note: self.note, is_kam: true, address_id: this.$route.params.id }

      axios.post('/api/verifications/allow', data).then((response) => {
        self.saving = false
        self.$notify({
          title: self.$i18n.t('core.saved'),
          text: self.$i18n.t('sandoz.verification_allow')
        })
        self.$refs['controls_' + this.verification].innerHTML = '<span class="badge badge-success">' + self.$i18n.t('sandoz.verified') + '</span>'
        self.closeAllowModel()
      }).catch((error) => {
        self.saving = false
        if ('data' in error.response && 'message' in error.response.data) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', {message: error.response.data.message}),
            type: 'error'
          })
        } else {
          self.$notify({
            title: self.$i18n.t('core.save_error'),
            text: self.$i18n.t('core.save_error_text', {url: ''}),
            type: 'error'
          })
        }
        self.closeAllowModel()
      })
    },
    hasPermission(item) {
      let result = true
      let permissions = item
      let user = this.user
      if (!user.is_super_user && permissions) {
        permissions.forEach((permission) => {
          if (!user.routePermissions.includes(permission)) {
            result = false
          }
        })
      }
      return result
    },
    openPictureOverlay (id) {
      var self = this
      self.pictures = []

      return axios
          .get('/api/verifications/pictures/' + id + '/' + true + '/' + this.$route.params.id)
          .then((response) => {
            self.verificationPictures = response.data
            if (self.verificationPictures && self.verificationPictures.length) {
              self.verificationPictures.forEach(function (item) {
                var src = '/verifications/' + id + '/' + item.picture;
                var extension = item.picture.split('.').pop().toLowerCase();
                if(extension !== 'png' && extension !== 'jpg' && extension !== 'jpeg') {
                  if(extension === 'doc' || extension === 'docx') {
                    extension = 'doc';
                  }
                   if(extension === 'xlsx' || extension === 'xls') {
                    extension = 'xls';
                  }
                  if(extension === 'html' || extension === 'eml' || extension === 'txt' || extension === 'msg') {
                    extension = 'html';
                  }
                  src = '/images/'+extension+'-icon.png'
                }
                self.pictures.push({
                  key:item.id,
                  src: src,
                  alt: item.picture,
                  description: self.$i18n.t('sandoz.latitude') + ': ' +
                      item.latitude + ', ' + self.$i18n.t('sandoz.longitude') + ': ' +
                      item.longitude + ', ' + self.$i18n.t('sandoz.distance') + ': ' +
                      (Vue.filter('formatDistance')(item.distance))
                })
              })
              self.$refs.verificationSilentBox.openOverlay(self.pictures[0], 0)
            } else {
              self.$notify({
                title: self.$i18n.t('core.error'),
                text: self.$i18n.t('sandoz.picture_not_found'),
                type: 'warning'
              })
            }
          })
          .catch((error) => {
            self.$notify({
              title: self.$i18n.t('core.error_alert_title'),
              text: self.$i18n.t('core.error_alert_text'),
              type: 'error'
            })
          })
    },
    clearFiles () {
      this.$refs.verificationUpload.removeAllFiles()
    },
    canDownload (meta) {
      if (this.hasPermission(['GET api/contracts/{id}/pdf']) && meta.item.contract) {
        if (meta.item.contract.is_kam) {
          return !!this.user.is_kam_user
        }
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss">
.contract_detail {
  label {
    font-weight: bold;
    margin-bottom: 0;
  }
}
.mwp-100 {
  max-width: 100px;
}
.mw-133 {
  max-width: 133px;
}
.mw-200 {
  max-width: 200px;
}
</style>
